import { FC } from 'react';
import { Action, Root } from './styled';
import closeIconActive from 'assets/vectors/close-icon-active.svg';
import closeIconInactive from 'assets/vectors/close-icon-inactive.svg';
import playIconActive from 'assets/vectors/play-icon-active.svg';
import playIconInactive from 'assets/vectors/play-icon-inactive.svg';
import IconButton from 'components/UI/IconButton';
import Tooltip from 'components/UI/Tooltip';

type Props = {
  onClickStart: (e: any) => void;
  enablePlayButton: boolean;
  onClickCancel: (e: any) => void;
  enableCancelButton: boolean;
};

const ActionsButtons: FC<Props> = ({
  onClickStart,
  enablePlayButton,
  onClickCancel,
  enableCancelButton,
}) => {
  return (
    <Root>
      <Action>
        <Tooltip paragraph={'start'} position="top">
          <IconButton
            onClick={onClickStart}
            enabled={enablePlayButton}
            data-testid="icon-play-button"
          >
            <img
              src={enablePlayButton ? playIconActive : playIconInactive}
              alt="start"
            />
          </IconButton>
        </Tooltip>
      </Action>
      <Action>
        <Tooltip paragraph={'cancel'} position="top">
          <IconButton onClick={onClickCancel} enabled={enableCancelButton}>
            <img
              src={enableCancelButton ? closeIconActive : closeIconInactive}
              alt="cancel"
            />
          </IconButton>
        </Tooltip>
      </Action>
    </Root>
  );
};

export default ActionsButtons;
